export default `
  mutation adminDeleteUser($userId: String!, $email: String!) {
    adminDeleteUser(userId: $userId, email: $email) {
      id
      deleted
    }
  }
`
